import styled from 'styled-components/macro';
import { COLORS, TYPOGRAPHY } from 'styleguide';

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px 4px;
  border-bottom: 1px solid ${COLORS.line};
  ${TYPOGRAPHY.caption}
  color: ${COLORS.gray60};
`;

export default Row;
